import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DmCartBoxEditComponent } from 'src/app/components/carrinho/dm-card-box-edit/dm-card-box-edit.component';
import { DmCardEditModal } from 'src/app/components/carrinho/modal/dm-card-edit-modal/dm-card-edit-modal.component';
import { FormsModule } from '@angular/forms';
import { LoaderModule } from '../../loader/loader/loader.module';
import { DmCartEditComponent } from 'src/app/components/carrinho/dm-cart-edit/dm-cart-edit.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { CartPassageirosQtdModule } from '../cart-passageiros-qtd/cart-passageiros-qtd.module';
import { CartResumoStepsModule } from '../cart-resumo-steps/cart-resumo-steps.module';
import { ComboAeroportoModule } from '../../combo/combo-aeroporto/combo-aeroporto.module';
import { ComboCiaAereaModule } from '../../combo/combo-cia-aerea/combo-cia-aerea.module';
import { ComboHotelModule } from '../../combo/combo-hotel/combo-hotel.module';
import { CartDataServicoModule } from '../cart-data-servico/cart-data-servico.module';
import { CartDadosVooModule } from '../card-dados-voo/card-dados-voo.module';
import { ComboOrigemModule } from '../../combo/combo-origem/combo-origem.module';
import { ComboDestinoModule } from '../../combo/combo-destino/combo-destino.module';
import { ComboDataSelectComponent } from 'src/app/components/combos/combo-data-select/combo-data-select.component';
import { ComboDataSelectModule } from '../../combo/combo-data-select/combo-data-select.module';

@NgModule({
  declarations: [
    DmCartBoxEditComponent,
    DmCartEditComponent,
    DmCardEditModal
  ],
  exports: [
    DmCartEditComponent,
    DmCartBoxEditComponent,
    DmCardEditModal
  ],
  entryComponents: [
    DmCardEditModal
  ],
  imports: [
    CartDadosVooModule, 
    LazyLoadImageModule,
    LoaderModule,
    FormsModule,
    CommonModule,
    CartPassageirosQtdModule,    
    CartResumoStepsModule,
    ComboAeroportoModule, 
    ComboCiaAereaModule,
    ComboHotelModule,
    CartDataServicoModule,
    ComboOrigemModule,
    ComboDestinoModule,
    ComboDataSelectModule
  ]
})
export class CartEditModule { }
